
import Http from "../helpers/Http";

class ConfigurationDataService {
  getAll() {
    return Http.get("/parameters");
  }

  update(data) {
    return Http.update("/parameters",data);
  }

}

export default new ConfigurationDataService();